import { defineAsyncComponent, markRaw } from 'vue'
// mode=1 健管工单，2为BD工单
export const tabs = [
  {
    label: '工单详情',
    key: 1,
    ref: 'workorderDetails',
    component: markRaw(defineAsyncComponent(() => import('@/views/Todo/workorderDetails.vue'))),
    mode: 1 //普通模式为1，工单质检为2
  },
  {
    label: '工单详情',
    key: 17,
    ref: 'bdOrderDetail',
    component: markRaw(defineAsyncComponent(() => import('./components/bdOrderDetail'))),
    mode: 2
  },
  {
    label: '会话记录',
    key: 2,
    ref: 'chat',
    component: markRaw(
      defineAsyncComponent(() => import('@/views/WorkPlace/Container/chat/history.vue'))
    ),
    mode: 1
  },
  {
    label: '通话记录',
    key: 11,
    ref: 'CallLog',
    component: markRaw(
      defineAsyncComponent(() => import('@/views/WorkPlace/Container/CallLog/index.vue'))
    ),
    mode: 1
  },
  {
    label: '短信记录',
    key: 15,
    ref: 'SMS',
    component: markRaw(
      defineAsyncComponent(() => import('@/views/WorkPlace/Container/SMS/index.vue'))
    ),
    mode: 1
  },
  {
    label: '处理痕迹',
    key: 14,
    ref: 'handlingTrace',
    component: markRaw(
      defineAsyncComponent(() =>
        import('@/components/PatientInfoDetails/components/handlingTrace.vue')
      )
    ),
    mode: 1
  },
  {
    label: '问诊',
    key: 4,
    ref: 'Consult',
    component: markRaw(
      defineAsyncComponent(() => import('@/views/WorkPlace/Container/Consult/index.vue'))
    ),
    mode: 1
  },
  {
    label: '处方',
    key: 6,
    ref: 'Prescription',
    component: markRaw(
      defineAsyncComponent(() => import('@/views/WorkPlace/Container/Prescription/index.vue'))
    ),
    mode: 1
  },
  {
    label: '病历',
    key: 5,
    ref: 'MedicalRecord',
    component: markRaw(
      defineAsyncComponent(() => import('@/views/WorkPlace/Container/MedicalRecord/index.vue'))
    ),
    mode: 1
  },
  {
    label: '预约',
    key: 9,
    ref: 'Appoint',
    component: markRaw(
      defineAsyncComponent(() => import('@/views/WorkPlace/Container/Appoint/index.vue'))
    ),
    mode: 1
  },
  {
    label: '量表',
    key: 7,
    ref: 'Gauge',
    component: markRaw(
      defineAsyncComponent(() => import('@/views/WorkPlace/Container/Gauge/index.vue'))
    ),
    mode: 1
  },

  {
    label: '小结',
    key: 10,
    ref: 'Summary',
    component: markRaw(
      defineAsyncComponent(() => import('@/views/WorkPlace/Container/Summary/index.vue'))
    ),
    mode: 1
  },
  {
    label: '随访',
    key: 8,
    ref: 'Visits',
    component: markRaw(
      defineAsyncComponent(() => import('@/views/WorkPlace/Container/Visits/index.vue'))
    ),
    mode: 1
  },
  {
    label: '绑定医生',
    key: 12,
    ref: 'bindDocList',
    component: markRaw(
      defineAsyncComponent(() =>
        import('@/components/PatientInfoDetails/components/bindDocList.vue')
      )
    ),
    mode: 1
  },

  {
    label: '工单质检',
    key: 16,
    ref: 'orderInspection',
    component: markRaw(defineAsyncComponent(() => import('./components/inspectionData'))),
    mode: 2
  },
  {
    label: '健康信息',
    key: 3,
    ref: 'healthInfo',
    component: markRaw(defineAsyncComponent(() => import('@/views/HealthRecord/HealthInfo'))),
    mode: 1
  },
  {
    label: '绩效指标',
    key: 13, // 详情中针对key去做了处理，所以老key不能更改
    ref: 'performanceIndex',
    component: markRaw(
      defineAsyncComponent(() =>
        import('@/components/PatientInfoDetails/components/performanceIndex.vue')
      )
    ),
    mode: 1
  }
]
export const followUpTabs = {
  label: '院内随访',
  key: 18,
  ref: 'followUp',
  component: markRaw(
    defineAsyncComponent(() => import('@/views/WorkPlace/Container/FollowUp/index.vue'))
  ),
  mode: 1
}

// 默认全部Tab
export const defaultOrderTabs = tabs.map(item => {
  if (item.mode === 1) {
    return item.ref
  }
})

// 特殊类型对应Tab
export const specialOrderTabs = {
  10: defaultOrderTabs, // 1.8放开导诊群限制
  28: [
    'workorderDetails',
    'performanceIndex',
    'handlingTrace',
    'chat',
    'CallLog',
    'SMS',
    'followUp'
  ],
  29: [
    'workorderDetails',
    'performanceIndex',
    'handlingTrace',
    'chat',
    'CallLog',
    'SMS',
    'followUp'
  ],
  34: [
    'workorderDetails',
    'performanceIndex',
    'handlingTrace',
    'chat',
    'CallLog',
    'SMS',
    'followUp'
  ]
}
// BD工单
export const BDOrderTabs = ['bdOrderDetail', 'handlingTrace', 'orderInspection']
// 含有子工单
export const subOrderTypes = [
  33 // 复诊提醒工单
]

// 子工单类型配置
export const subOrderTabConfigs = {
  1: {
    tabsConfig: {
      supportTabs: [
        'workorderDetails',
        'chat',
        'performanceIndex',
        'handlingTrace',
        'orderInspection',
        'CallLog',
        'SMS',
        'followUp'
      ],
      activeKey: 1
    }
  },
  2: {
    tabsConfig: {
      supportTabs: defaultOrderTabs.concat(['orderInspection']),
      activeKey: 1
    }
  },
  3: {
    //BD工单
    tabsConfig: {
      supportTabs: BDOrderTabs,
      activeKey: 1
    }
  }
}
